import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NomOrgComponent } from './nom-org.component';
import { NomOrgsRoutingModule } from './nom-orgs-routing.module';
import { NomOrgProjectComponent } from './nom-org-project/nom-org-project.component';
import { ControlsModule } from '../controls/controls.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NomOrgRepresentativeComponent } from './nom-org-representative/nom-org-representative.component';
import { ButtonExportRepresentativesComponent } from './button-export-representatives/button-export-representatives.component';
import { NomOrgCommitteeComponent } from './nom-org-committee/nom-org-committee.component';



@NgModule({
  declarations: [
    NomOrgComponent,
    NomOrgProjectComponent,
    NomOrgRepresentativeComponent,
    ButtonExportRepresentativesComponent,
    NomOrgCommitteeComponent
  ],
  imports: [
    CommonModule,
    NomOrgsRoutingModule,
    ControlsModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class NomOrgsModule { }
